import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import useApiData from "../../../hooks/useApiData";

interface Client {
  id: number;
  name: string;
}

interface ClientFilterProps {
  value: number | undefined;
  onChange: (clientId: number | undefined) => void;
}

export default function ClientFilter({ value, onChange }: ClientFilterProps) {
  const { apiData } = useApiData();
  const clients = apiData?.clients || [];

  // Encontrar cliente selecionado
  const selectedClient =
    clients.find((client: Client) => client.id === value) || null;

  const handleChange = (_event: any, newValue: Client | null) => {
    onChange(newValue ? newValue.id : undefined);
  };

  return (
    <Autocomplete
      options={clients}
      value={selectedClient}
      onChange={handleChange}
      getOptionLabel={(option: Client) => option.name}
      isOptionEqualToValue={(option: Client, value: Client) =>
        option.id === value.id
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Cliente"
          placeholder="Selecione um cliente"
        />
      )}
    />
  );
}

